export enum AuctionType {
  Unknown = 0,
  SellItem = 1,
  SearchItem = 2,
  ServiceOffer = 3,
  ServiceNeeded = 4,
  Rent = 5,
  Trade = 6
}
